import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Target, Globe, Eye, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { visionStatement, visionPillars, aboutLinks, publicCtas } from '@/content/public-site-content';

const pillarIconMap: Record<string, React.ElementType> = {
  Target,
  Globe,
  Eye,
};

export default function VisionPage() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 p-6">
      <section className="rounded-[2rem] border border-border/70 bg-card/90 p-8 shadow-sm">
        <div className="space-y-4 text-center">
          <Badge variant="outline" className="mx-auto mb-2 w-fit">
            <Eye className="mr-1 h-3 w-3" />
            Vision
          </Badge>
          <h1 className="text-4xl font-bold tracking-tight">Raising Leaders That Transform Society</h1>
          <p className="mx-auto max-w-2xl text-xl text-muted-foreground">
            This is the direction that shapes the ministry and the people we are raising.
          </p>
        </div>
      </section>

      <Card className="bg-primary/5 border-primary/20">
        <CardContent className="p-8">
          <h2 className="text-2xl font-bold mb-4 text-center">Our Mandate</h2>
          <p className="text-lg text-muted-foreground text-center max-w-3xl mx-auto">
            {visionStatement}
          </p>
        </CardContent>
      </Card>

      <div className="grid gap-6 md:grid-cols-3">
        {visionPillars.map((pillar) => {
          const Icon = pillarIconMap[pillar.icon] ?? Target;
          return (
            <Card key={pillar.title} className="border-border/70 bg-card/90 shadow-sm">
              <CardHeader>
                <Icon className="h-8 w-8 text-primary mb-2" />
                <CardTitle className="text-xl">{pillar.title}</CardTitle>
                <CardDescription className="text-sm">{pillar.description}</CardDescription>
              </CardHeader>
            </Card>
          );
        })}
      </div>

      <Card className="border-border/70">
        <CardContent className="p-8 text-center">
          <h2 className="text-xl font-bold mb-2">Explore More</h2>
          <p className="text-muted-foreground mb-6">
            Move on to the ministry values, testimony, or the public broadcast.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {aboutLinks.filter(l => l.label !== 'Overview' && l.label !== 'Vision').map((link) => (
              <Link key={link.href} to={link.href}>
                <Badge variant="outline" className="text-sm px-4 py-2 cursor-pointer hover:bg-primary/10">
                  {link.label}
                </Badge>
              </Link>
            ))}
            {publicCtas.slice(1, 4).map((cta) => (
              <Link key={cta.href} to={cta.href}>
                <Button variant={cta.href === '/media' ? 'default' : 'outline'}>
                  {cta.label}
                  {cta.href === '/media' && <ArrowRight className="ml-2 h-4 w-4" />}
                </Button>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
